import React from 'react'
import { Endpoint as FHIREndpoint } from '@teschglobal/tg-fhir-react-components/dist/types'
import { useGlobalState } from '../../../../../hooks/store/useGlobalState'
import { Endpoint } from '@teschglobal/tg-fhir-react-components'

type EndpointDetailProps = {
    resource: FHIREndpoint | null;
    isFetching: boolean;
}

const EndpointDetail: React.FC<EndpointDetailProps> = ({ resource }) => {
    const endpointFromState = useGlobalState(state => state.endpoint)

    const resolvedResource = resource ?? endpointFromState ?? undefined


    return (
        <section>
            <h3>Endpoint</h3>
            <Endpoint data={resolvedResource} />
        </section>
    )
}

export default EndpointDetail